import { ModuleWithProviders, NgModule } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Observable } from 'rxjs';
import missingTranslationJson from '../assets/i18n/missingTranslations.json';

export class CustomTranslateLoader implements TranslateLoader {
	constructor(private httpClient: HttpClient) {}

	getTranslation(lang: string): Observable<any> {
		var fnLoadDefaultFile = () => {
			return this.httpClient.get(`assets/i18n/${lang}.json`).toPromise();
		};

		var fnLoadFromTool = () => {
			return new Promise((resolve, reject) => {
				this.httpClient
					.get(environment.baseUrl + '/translations/' + lang, {})
					.toPromise()
					.then(
						(response: any) => {
							if (response.status != 200) {
								fnLoadDefaultFile().then(resolve, reject);
							} else {
								resolve(response.body);
							}
						},
						err => {
							reject(err);
						},
					);
			});
		};
		return new Observable(observer => {
			var prm = !environment.useTranslationTool ? fnLoadDefaultFile : fnLoadFromTool;
			prm().then(
				response => {
					observer.next(response);
					observer.complete();
				},
				err => {
					observer.complete();
				},
			);
		});
	}
}
/* handle missing translations on DEV */
export class MyMissingTranslationHandler implements MissingTranslationHandler {
	handle(params: MissingTranslationHandlerParams) {
		return missingTranslationJson.alternativeTranslationJson.hasOwnProperty(params.key) ? missingTranslationJson.alternativeTranslationJson[params.key] : params.key;
	}
}
/* handle missing translations on DEV END*/

@NgModule({
	declarations: [],
	exports: [TranslateModule],
	imports: [
		HttpClientModule,
		TranslateModule.forRoot({
			missingTranslationHandler: {
				provide: MissingTranslationHandler,
				useClass: MyMissingTranslationHandler,
			},
			loader: {
				provide: TranslateLoader,
				useClass: CustomTranslateLoader,
				deps: [HttpClient],
			},
		}),
	],
})
export class AppTranslateModule {
	static forRoot(): ModuleWithProviders<AppTranslateModule> {
		return {
			ngModule: AppTranslateModule,
			providers: [],
		};
	}
}
